import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";
import { isRoomCategoryAvailable } from "../../helpers/roomCategory";
import RoomCategoryCard from "./RoomCategoryCard";

function Accommodations() {
  const hotel = useAppSelector(selectHotel);

  const roomCategories = [...hotel.RoomCategories].sort(
    (a, b) =>
      Number(isRoomCategoryAvailable(b.Id)) -
      Number(isRoomCategoryAvailable(a.Id)),
  );

  return (
    <>
      <div className="grid grid-cols-1 gap-4">
        {roomCategories.map((roomCategory) => {
          return (
            <RoomCategoryCard
              key={roomCategory.Id}
              roomCategory={roomCategory}
            />
          );
        })}
      </div>
    </>
  );
}

export default Accommodations;
